import { CheckmarkCircleSvg } from "@@/orders/order-groups/checkmark-circle-svg";
import { VerticalDivider } from "@@/shared/dividers/vertical-divider";
import { FlexColumn, FlexRow } from "@@/shared/flex-containers";
import { GlobalMaxWidthCss } from "@@/shared/global-max-width";
import { TextBox } from "@@/shared/text/text-box";
import { useTheme } from "@emotion/react";

const SignOutFromBackOfficeSuccessfulPage = () => {
    const theme = useTheme();
    return (
        <>
            <GlobalMaxWidthCss />
            <FlexColumn
                crossAxis="center"
                css={{
                    flex: 1,
                    backgroundColor: theme.colors.default.background.asString,
                }}>
                <FlexColumn
                    mainAxis="center"
                    crossAxis="center"
                    css={{ flex: 1, paddingBottom: 40 }}>
                    <FlexRow
                        fillParentWidth
                        mainAxis="center"
                        crossAxis="center"
                        css={{ paddingTop: 10 }}>
                        <CheckmarkCircleSvg
                            size={"5rem"}
                            circleColor={theme.colors.primary.main.withAlpha(
                                0.7,
                            )}
                            checkmarkColor={theme.colors.primary}
                        />
                    </FlexRow>
                    <VerticalDivider M />
                    <TextBox
                        text={{
                            sv: "Du är nu utloggad!",
                            en: "You are now signed out!",
                        }}
                        weight="900"
                        size="XL"
                        align="center"
                        padding={{ all: 20 }}
                    />
                    <TextBox
                        text={{
                            sv: "Välkommen tillbaka en annan gång.",
                            en: "Welcome back another time.",
                        }}
                        weight="400"
                        size="ML"
                        align="center"
                    />
                </FlexColumn>
            </FlexColumn>
        </>
    );
};

export { SignOutFromBackOfficeSuccessfulPage };
